import React, { useState, useEffect } from "react";
import { useCookies } from 'react-cookie';
import Axios from 'axios';
import Sidebar from './SideBar';
import Swal from 'sweetalert2';
import config from './Componentes/config';
import useAuthRedirect from "./Componentes/auth";
import { registrarLog } from './Componentes/logService';
import $ from "jquery";
import jsPDF from 'jspdf';
import 'jspdf-autotable';

const cardImages = {
    DAFA: "/img/dafaLogo.png",
    FUGA: "/img/fugarLogo.png",
    INVE: "/img/idafaLogo.png",
    TRAN: "/img/extasisLogo.png",
    NIDI: "/img/nidiamLogo.png"
};

function Inventario() {
    useAuthRedirect();
    const [cookies] = useCookies(['selectedCard']);
    const imageUrl = cardImages[cookies.selectedCard];
    const idEmpresa = cookies.idEmpresa;
    const NombreEmpresa = cookies.NombreEmpresa;
    const userName = cookies.usuario;

    // Estados para el colapso del sidebar
    const [isComponentsCollapsed, setIsComponentsCollapsed] = useState(true);
    const [isUtilitiesCollapsed, setIsUtilitiesCollapsed] = useState(true);
    const [isInventario, setisIventatioCollapsed] = useState(true);
    const [isPrevencion, setisPrevencionCollapsed] = useState(true);
    const [isLogistica, setisLogisticaCollapsed] = useState(true);
    const [isContabilidadCollapsed, setIsContabilidadCollapsed] = useState(true);

    const toggleCollapse = (collapseSetter) => {
        collapseSetter(prevState => !prevState);
    };

    // Estados para el formulario de productos
    const [codigoProducto, setCodigoProducto] = useState(""); // Solo para mostrar, no editable
    const [codigoPreview, setCodigoPreview] = useState(""); // Vista previa del código que se generará
    const [nombreProducto, setNombreProducto] = useState("");
    const [idTipo, setIdTipo] = useState("");
    const [marca, setMarca] = useState("");
    const [estado, setEstado] = useState("Activo");

    // Estados para el detalle de inventario
    const [codigoIndividual, setCodigoIndividual] = useState(""); // Solo para mostrar
    const [codigoIndividualPreview, setCodigoIndividualPreview] = useState(""); // Vista previa
    const [talla, setTalla] = useState("");
    const [color, setColor] = useState("");
    const [estadoUnidad, setEstadoUnidad] = useState("Disponible");
    const [observaciones, setObservaciones] = useState("");
    const [cantidadAgregar, setCantidadAgregar] = useState(1);

    // Estados para listas y control
    const [tiposProducto, setTiposProducto] = useState([]);
    const [productos, setProductos] = useState([]);
    const [detalleInventario, setDetalleInventario] = useState([]);
    const [editar, setEditar] = useState(false);
    const [productoSeleccionado, setProductoSeleccionado] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [vistaActual, setVistaActual] = useState("productos"); // "productos" o "detalle"

    // Estados para la navegación jerárquica del inventario detallado
    const [nivelActual, setNivelActual] = useState("tipos"); // "tipos", "productos", "unidades"
    const [tipoSeleccionadoDetalle, setTipoSeleccionadoDetalle] = useState(null);
    const [productoSeleccionadoDetalle, setProductoSeleccionadoDetalle] = useState(null);
    const [rutaNavegacion, setRutaNavegacion] = useState([]);

    // Estados para tipos de producto
    const [showTipoModal, setShowTipoModal] = useState(false);
    const [nombreTipo, setNombreTipo] = useState("");
    const [descripcionTipo, setDescripcionTipo] = useState("");
    const [esEPP, setEsEPP] = useState("No");
    const [editarTipo, setEditarTipo] = useState(false);
    const [tipoSeleccionado, setTipoSeleccionado] = useState(null);

    // Estados para reporte PDF
    const [showReporteModal, setShowReporteModal] = useState(false);
    const [tipoReporte, setTipoReporte] = useState("tipos");
    const [fechaDesde, setFechaDesde] = useState("");
    const [fechaHasta, setFechaHasta] = useState("");
    const [incluirAsignaciones, setIncluirAsignaciones] = useState(true);

    // Estados para modal de variaciones
    const [showVariacionesModal, setShowVariacionesModal] = useState(false);
    const [productoVariaciones, setProductoVariaciones] = useState(null);
    const [variaciones, setVariaciones] = useState([
        { talla: '', color: '', cantidad: 1, codigo_individual: '' }
    ]);

    // Estados para trabajadores (para asignación manual)
    const [trabajadores, setTrabajadores] = useState([]);

    // Cargar datos iniciales
    useEffect(() => {
        cargarTiposProducto();
        cargarProductos();
        cargarDetalleInventario();
        cargarTrabajadores();
    }, [idEmpresa]);

    const cargarTrabajadores = async () => {
        try {
            const response = await Axios.get(`${config.API_URL}/getTrabajadores`, {
                params: { id: idEmpresa, estado: 'Vigente' }
            });
            setTrabajadores(response.data);
        } catch (error) {
            console.error("Error al cargar trabajadores:", error);
        }
    };

    const cargarTiposProducto = async () => {
        try {
            const response = await Axios.get(`${config.API_URL}/getTiposProducto`);
            setTiposProducto(response.data);
        } catch (error) {
            console.error("Error al cargar tipos de producto:", error);
        }
    };

    const cargarProductos = async () => {
        try {
            const response = await Axios.get(`${config.API_URL}/getProductosInventario`, {
                params: { idEmpresa }
            });
            // Validación defensiva para asegurar que siempre sea un array
            if (Array.isArray(response.data)) {
                setProductos(response.data);
            } else {
                console.warn("La respuesta de productos no es un array:", response.data);
                setProductos([]); // Fallback a array vacío
            }
        } catch (error) {
            console.error("Error al cargar productos:", error);
            setProductos([]); // En caso de error, asegurar array vacío
        }
    };

    const cargarDetalleInventario = async () => {
        try {
            const response = await Axios.get(`${config.API_URL}/getDetalleInventario`, {
                params: { idEmpresa }
            });
            // Validación defensiva para asegurar que siempre sea un array
            if (Array.isArray(response.data)) {
                setDetalleInventario(response.data);
            } else {
                console.warn("La respuesta de detalle inventario no es un array:", response.data);
                setDetalleInventario([]); // Fallback a array vacío
            }
        } catch (error) {
            console.error("Error al cargar detalle de inventario:", error);
            setDetalleInventario([]); // En caso de error, asegurar array vacío
        }
    };

    // Generar vista previa del código de producto
    const generarVistaPreviewProducto = () => {
        if (nombreProducto && marca) {
            const prefijo = nombreProducto.substring(0, 3).toUpperCase();
            const marcaCorta = marca.substring(0, 3).toUpperCase();
            const preview = `${prefijo}-${marcaCorta}`;
            setCodigoPreview(preview);
        } else if (nombreProducto) {
            const prefijo = nombreProducto.substring(0, 3).toUpperCase();
            setCodigoPreview(`${prefijo}-GEN`);
        } else {
            setCodigoPreview("");
        }
    };

    // Generar vista previa del código individual
    const generarVistaPreviewIndividual = () => {
        if (codigoPreview) {
            let preview = codigoPreview;
            if (talla) preview += `-${talla}`;
            if (color) preview += `-${color}`;
            if (cantidadAgregar > 1) preview += `-001...`;
            setCodigoIndividualPreview(preview);
        } else {
            setCodigoIndividualPreview("");
        }
    };

    // Efecto para actualizar vista previa cuando cambian los campos
    useEffect(() => {
        generarVistaPreviewProducto();
    }, [nombreProducto, marca]);

    useEffect(() => {
        generarVistaPreviewIndividual();
    }, [codigoPreview, talla, color, cantidadAgregar]);

    const validarFormularioProducto = () => {
        if (!nombreProducto.trim()) return "El nombre del producto es obligatorio";
        if (!idTipo) return "Debe seleccionar un tipo de producto";
        return null;
    };

    const limpiarFormulario = () => {
        setCodigoProducto("");
        setCodigoPreview("");
        setNombreProducto("");
        setIdTipo("");
        setMarca("");
        setEstado("Activo");
        setCodigoIndividual("");
        setCodigoIndividualPreview("");
        setTalla("");
        setColor("");
        setEstadoUnidad("Disponible");
        setObservaciones("");
        setCantidadAgregar(1);
        setEditar(false);
        setProductoSeleccionado(null);
    };

    const registrarProducto = async () => {
        const mensajeError = validarFormularioProducto();
        if (mensajeError) {
            Swal.fire('Error de validación', mensajeError, 'warning');
            return;
        }

        try {
            const datosProducto = {
                idEmpresa,
                nombreProducto,
                idTipo,
                marca,
                estado,
                usuarioCreacion: userName
            };

            let response;
            if (editar) {
                response = await Axios.put(`${config.API_URL}/updateProductoInventario`, {
                    ...datosProducto,
                    idProducto: productoSeleccionado.ID_Producto
                });
            } else {
                response = await Axios.post(`${config.API_URL}/createProductoInventario`, datosProducto);
            }

            if (response.data.success) {
                Swal.fire('Éxito', editar ? 'Producto actualizado correctamente' : 'Producto registrado correctamente', 'success');

                // Si no estamos editando y tenemos cantidad para agregar, agregar unidades al inventario
                if (!editar && cantidadAgregar > 0 && response.data.idProducto) {
                    await agregarUnidadesInventario(response.data.idProducto);
                }

                limpiarFormulario();
                cargarProductos();
                cargarDetalleInventario();
                setShowModal(false);

                // Registrar log
                await registrarLog(userName, 'Inventario', editar ? `Producto actualizado: ${nombreProducto}` : `Producto creado: ${nombreProducto}`, 'success');
            }
        } catch (error) {
            console.error("Error al registrar producto:", error);
            Swal.fire('Error', 'Error al registrar el producto', 'error');
        }
    };

    const agregarUnidadesInventario = async (idProducto) => {
        try {
            const unidades = [];
            for (let i = 0; i < cantidadAgregar; i++) {
                unidades.push({
                    idProducto,
                    talla,
                    color,
                    estadoUnidad,
                    observaciones,
                    usuarioRegistro: userName
                });
            }

            const response = await Axios.post(`${config.API_URL}/createDetalleInventario`, { unidades });

            if (response.data.success) {
                console.log("Códigos generados:", response.data.codigosGenerados);
            }
        } catch (error) {
            console.error("Error al agregar unidades al inventario:", error);
        }
    };

    // Funciones para navegación jerárquica del inventario detallado
    const navegarATipo = (tipo) => {
        setTipoSeleccionadoDetalle(tipo);
        setNivelActual("productos");
        setRutaNavegacion([{ nivel: "tipos", texto: "Tipos de Producto" }]);
    };

    const navegarAProducto = (producto) => {
        setProductoSeleccionadoDetalle(producto);
        setNivelActual("unidades");
        setRutaNavegacion([
            { nivel: "tipos", texto: "Tipos de Producto" },
            { nivel: "productos", texto: tipoSeleccionadoDetalle?.Nombre_Tipo || "Productos" }
        ]);
    };

    const navegarANivel = (nivel) => {
        if (nivel === "tipos") {
            setNivelActual("tipos");
            setTipoSeleccionadoDetalle(null);
            setProductoSeleccionadoDetalle(null);
            setRutaNavegacion([]);
        } else if (nivel === "productos") {
            setNivelActual("productos");
            setProductoSeleccionadoDetalle(null);
            setRutaNavegacion([{ nivel: "tipos", texto: "Tipos de Producto" }]);
        }
    };

    // Obtener productos filtrados por tipo
    const getProductosPorTipo = (idTipo) => {
        return productos.filter(producto => producto.ID_Tipo === idTipo);
    };

    // Obtener unidades por producto
    const getUnidadesPorProducto = (idProducto) => {
        return detalleInventario.filter(detalle => detalle.ID_Producto === idProducto);
    };

    // Obtener icono para cada tipo de producto
    const getIconoTipo = (nombreTipo) => {
        const iconos = {
            'Cascos': 'fas fa-hard-hat',
            'CascosSeguridad': 'fas fa-hard-hat',
            'Guantes': 'fas fa-hand-paper',
            'Zapatos': 'fas fa-shoe-prints',
            'ZapatosSeguridad': 'fas fa-shoe-prints',
            'Chalecos': 'fas fa-vest',
            'Overoles': 'fas fa-tshirt',
            'Lentes': 'fas fa-glasses',
            'LentesSeguridad': 'fas fa-glasses',
            'Mascarillas': 'fas fa-head-side-mask',
            'Respiradores': 'fas fa-head-side-mask',
            'default': 'fas fa-box'
        };

        // Buscar coincidencia exacta o parcial
        const nombreLimpio = nombreTipo.replace(/\s+/g, '');
        return iconos[nombreLimpio] || iconos[nombreTipo] || iconos.default;
    };

    // Resetear navegación cuando se cambia a vista detallada
    useEffect(() => {
        if (vistaActual === 'detalle') {
            // Destruir DataTable de productos si existe para evitar conflictos
            if ($.fn.DataTable.isDataTable('#productosTable')) {
                $('#productosTable').DataTable().destroy();
            }
            setNivelActual("tipos");
            setTipoSeleccionadoDetalle(null);
            setProductoSeleccionadoDetalle(null);
            setRutaNavegacion([]);
        }
    }, [vistaActual]);

    const editarProducto = (producto) => {
        setEditar(true);
        setProductoSeleccionado(producto);
        setCodigoProducto(producto.Codigo_Producto); // Solo para mostrar
        setCodigoPreview(producto.Codigo_Producto); // Mostrar código actual
        setNombreProducto(producto.Nombre_Producto);
        setIdTipo(producto.ID_Tipo);
        setMarca(producto.Marca || "");
        setEstado(producto.Estado);
        setShowModal(true);
    };

    const eliminarProducto = (producto) => {
        Swal.fire({
            title: '¿Está seguro?',
            text: `¿Desea eliminar el producto "${producto.Nombre_Producto}"?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await Axios.delete(`${config.API_URL}/deleteProductoInventario/${producto.ID_Producto}`);
                    Swal.fire('Eliminado', 'El producto ha sido eliminado correctamente', 'success');
                    cargarProductos();
                    cargarDetalleInventario();

                    // Registrar log
                    await registrarLog(userName, 'Inventario', `Producto eliminado: ${producto.Nombre_Producto}`, 'success');
                } catch (error) {
                    console.error("Error al eliminar producto:", error);
                    Swal.fire('Error', 'Error al eliminar el producto', 'error');
                }
            }
        });
    };

    const confirmarRegistro = () => {
        Swal.fire({
            title: '¿Está seguro?',
            text: editar ? '¿Desea actualizar este producto?' : '¿Desea registrar este producto?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: editar ? 'Sí, actualizar' : 'Sí, registrar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                registrarProducto();
            }
        });
    };

    // Función para cambiar el estado de una unidad
    const cambiarEstadoUnidad = async (detalle) => {
        const { value: formValues } = await Swal.fire({
            title: 'Cambiar Estado de Unidad',
            html: `
                <div style="text-align: left; margin-bottom: 20px;">
                    <p><strong>Código:</strong> ${detalle.Codigo_Individual || 'Sin código'}</p>
                    <p><strong>Producto:</strong> ${detalle.Nombre_Producto}</p>
                    <p><strong>Estado Actual:</strong> ${detalle.Estado_Unidad.replace('_', ' ')}</p>
                </div>
                <div style="margin-bottom: 15px;">
                    <label for="swal-nuevo-estado" style="display: block; margin-bottom: 5px; font-weight: bold;">Nuevo Estado:</label>
                    <select id="swal-nuevo-estado" class="swal2-input" style="width: 100%;">
                        <option value="">Seleccione un estado</option>
                        <option value="Disponible" ${detalle.Estado_Unidad === 'Disponible' ? 'disabled' : ''}>Disponible</option>
                        <option value="Asignado" ${detalle.Estado_Unidad === 'Asignado' ? 'disabled' : ''}>Asignado</option>
                        <option value="En_Reparacion" ${detalle.Estado_Unidad === 'En_Reparacion' ? 'disabled' : ''}>En Reparación</option>
                        <option value="Dado_De_Baja" ${detalle.Estado_Unidad === 'Dado_De_Baja' ? 'disabled' : ''}>Dado de Baja</option>
                    </select>
                </div>
                <div id="trabajador-container" style="display: none; margin-bottom: 15px;">
                    <label for="swal-trabajador" style="display: block; margin-bottom: 5px; font-weight: bold;">Trabajador a Asignar:</label>
                    <select id="swal-trabajador" class="swal2-input" style="width: 100%;">
                        <option value="">Seleccione un trabajador</option>
                        ${trabajadores.map(t => `<option value="${t.ID_Trabajador}">${t.Nombres} ${t.Apellidos} - ${t.Rut}</option>`).join('')}
                    </select>
                </div>
                <div>
                    <label for="swal-razon-cambio" style="display: block; margin-bottom: 5px; font-weight: bold;">Razón del Cambio:</label>
                    <textarea id="swal-razon-cambio" class="swal2-textarea" placeholder="Motivo del cambio de estado" style="width: 100%; min-height: 80px; padding: 10px; border: 1px solid #d1d3e2; border-radius: 0.35rem; font-size: 0.875rem; resize: vertical; box-sizing: border-box;"></textarea>
                </div>
            `,
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonText: 'Cambiar Estado',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#28a745',
            didOpen: () => {
                // Configurar el evento onchange después de que el modal se abra
                const estadoSelect = document.getElementById('swal-nuevo-estado');
                const trabajadorContainer = document.getElementById('trabajador-container');
                const trabajadorSelect = document.getElementById('swal-trabajador');

                estadoSelect.addEventListener('change', function () {
                    if (this.value === 'Asignado') {
                        trabajadorContainer.style.display = 'block';
                    } else {
                        trabajadorContainer.style.display = 'none';
                        trabajadorSelect.value = '';
                    }
                });
            },
            preConfirm: () => {
                const nuevoEstado = document.getElementById('swal-nuevo-estado').value;
                const razon = document.getElementById('swal-razon-cambio').value;
                const idTrabajador = document.getElementById('swal-trabajador').value;

                if (!nuevoEstado) {
                    Swal.showValidationMessage('Debe seleccionar un nuevo estado');
                    return false;
                }

                if (nuevoEstado === 'Asignado' && !idTrabajador) {
                    Swal.showValidationMessage('Debe seleccionar un trabajador para asignar');
                    return false;
                }

                if (!razon.trim()) {
                    Swal.showValidationMessage('Debe ingresar una razón para el cambio');
                    return false;
                }

                return { nuevoEstado, razon: razon.trim(), idTrabajador: idTrabajador || null };
            }
        });

        if (formValues) {
            try {
                const response = await Axios.put(`${config.API_URL}/cambiarEstadoUnidadConAsignacion`, {
                    idDetalle: detalle.ID_Detalle,
                    nuevoEstado: formValues.nuevoEstado,
                    razonCambio: formValues.razon,
                    idTrabajador: formValues.idTrabajador,
                    usuarioCambio: userName
                });

                if (response.data.success) {
                    await cargarDetalleInventario(); // Recargar datos
                    Swal.fire('Éxito', 'Estado cambiado correctamente', 'success');
                } else {
                    Swal.fire('Error', response.data.message || 'Error al cambiar el estado', 'error');
                }
            } catch (error) {
                console.error("Error al cambiar estado:", error);
                Swal.fire('Error', 'Error al cambiar el estado de la unidad', 'error');
            }
        }
    };

    // Inicializar DataTable cuando se cargan los productos
    useEffect(() => {
        if (productos.length > 0 && vistaActual === 'productos') {
            // Destruir DataTable existente si existe
            if ($.fn.DataTable.isDataTable('#productosTable')) {
                $('#productosTable').DataTable().destroy();
            }

            // Inicializar nuevo DataTable
            $('#productosTable').DataTable({
                language: {
                    "sProcessing": "Procesando...",
                    "sLengthMenu": "Mostrar _MENU_ registros",
                    "sZeroRecords": "No se encontraron resultados",
                    "sEmptyTable": "Ningún dato disponible en esta tabla",
                    "sInfo": "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
                    "sInfoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
                    "sInfoFiltered": "(filtrado de un total de _MAX_ registros)",
                    "sInfoPostFix": "",
                    "sSearch": "Buscar:",
                    "sUrl": "",
                    "sInfoThousands": ",",
                    "sLoadingRecords": "Cargando...",
                    "oPaginate": {
                        "sFirst": "Primero",
                        "sLast": "Último",
                        "sNext": "Siguiente",
                        "sPrevious": "Anterior"
                    },
                    "oAria": {
                        "sSortAscending": ": Activar para ordenar la columna de manera ascendente",
                        "sSortDescending": ": Activar para ordenar la columna de manera descendente"
                    }
                },
                responsive: true,
                pageLength: 10,
                order: [[1, 'asc']] // Ordenar por nombre de producto
            });
        }
    }, [productos, vistaActual]);

    // Inicializar DataTable para inventario detallado
    useEffect(() => {
        if (detalleInventario.length > 0) {
            // Destruir DataTable existente si existe
            if ($.fn.DataTable.isDataTable('#detalleTable')) {
                $('#detalleTable').DataTable().destroy();
            }

            // Inicializar nuevo DataTable
            $('#detalleTable').DataTable({
                language: {
                    "sProcessing": "Procesando...",
                    "sLengthMenu": "Mostrar _MENU_ registros",
                    "sZeroRecords": "No se encontraron resultados",
                    "sEmptyTable": "Ningún dato disponible en esta tabla",
                    "sInfo": "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
                    "sInfoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
                    "sInfoFiltered": "(filtrado de un total de _MAX_ registros)",
                    "sInfoPostFix": "",
                    "sSearch": "Buscar:",
                    "sUrl": "",
                    "sInfoThousands": ",",
                    "sLoadingRecords": "Cargando...",
                    "oPaginate": {
                        "sFirst": "Primero",
                        "sLast": "Último",
                        "sNext": "Siguiente",
                        "sPrevious": "Anterior"
                    },
                    "oAria": {
                        "sSortAscending": ": Activar para ordenar la columna de manera ascendente",
                        "sSortDescending": ": Activar para ordenar la columna de manera descendente"
                    }
                },
                responsive: true,
                pageLength: 10,
                order: [[0, 'asc']] // Ordenar por código de producto
            });
        }
    }, [detalleInventario]);

    // useEffect para bloquear scroll del body cuando modal está abierto
    useEffect(() => {
        if (showReporteModal || showVariacionesModal) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }

        // Cleanup function para restaurar el scroll al desmontar
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [showReporteModal, showVariacionesModal]);

    // ===============================
    // FUNCIONES PARA TIPOS DE PRODUCTO
    // ===============================

    const validarFormularioTipo = () => {
        if (!nombreTipo.trim()) return "El nombre del tipo es obligatorio";
        return null;
    };

    const limpiarFormularioTipo = () => {
        setNombreTipo("");
        setDescripcionTipo("");
        setEsEPP("No");
        setEditarTipo(false);
        setTipoSeleccionado(null);
    };

    const registrarTipoProducto = async () => {
        const mensajeError = validarFormularioTipo();
        if (mensajeError) {
            Swal.fire('Error de validación', mensajeError, 'warning');
            return;
        }

        try {
            const datosTipo = {
                nombreTipo,
                descripcion: descripcionTipo,
                esEPP
            };

            let response;
            if (editarTipo) {
                response = await Axios.put(`${config.API_URL}/updateTipoProducto`, {
                    ...datosTipo,
                    idTipo: tipoSeleccionado.ID_Tipo,
                    estado: 'Activo'
                });
            } else {
                response = await Axios.post(`${config.API_URL}/createTipoProducto`, datosTipo);
            }

            Swal.fire('Éxito',
                editarTipo ? 'Tipo de producto actualizado correctamente' : 'Tipo de producto registrado correctamente',
                'success'
            );

            limpiarFormularioTipo();
            setShowTipoModal(false);
            cargarTiposProducto();

            // Registrar log
            await registrarLog(userName, 'Inventario',
                editarTipo ? `Tipo de producto actualizado: ${nombreTipo}` : `Tipo de producto creado: ${nombreTipo}`,
                'success'
            );

        } catch (error) {
            console.error("Error al registrar tipo de producto:", error);
            Swal.fire('Error', 'Error al procesar el tipo de producto', 'error');
        }
    };

    const editarTipoProducto = (tipo) => {
        setEditarTipo(true);
        setTipoSeleccionado(tipo);
        setNombreTipo(tipo.Nombre_Tipo);
        setDescripcionTipo(tipo.Descripcion || "");
        setEsEPP(tipo.Es_EPP);
        setShowTipoModal(true);
    };

    const eliminarTipoProducto = (tipo) => {
        Swal.fire({
            title: '¿Está seguro?',
            text: `¿Desea eliminar el tipo "${tipo.Nombre_Tipo}"?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await Axios.delete(`${config.API_URL}/deleteTipoProducto`, {
                        data: { idTipo: tipo.ID_Tipo }
                    });
                    Swal.fire('Eliminado', 'El tipo de producto ha sido eliminado correctamente', 'success');
                    cargarTiposProducto();

                    // Registrar log
                    await registrarLog(userName, 'Inventario', `Tipo de producto eliminado: ${tipo.Nombre_Tipo}`, 'success');
                } catch (error) {
                    console.error("Error al eliminar tipo de producto:", error);
                    Swal.fire('Error', 'Error al eliminar el tipo de producto', 'error');
                }
            }
        });
    };

    const confirmarRegistroTipo = () => {
        Swal.fire({
            title: '¿Está seguro?',
            text: editarTipo ? '¿Desea actualizar este tipo de producto?' : '¿Desea registrar este tipo de producto?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: editarTipo ? 'Sí, actualizar' : 'Sí, registrar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                registrarTipoProducto();
            }
        });
    };

    // ===============================
    // FUNCIONES PARA VARIACIONES DE PRODUCTOS
    // ===============================

    const abrirModalVariaciones = (producto) => {
        setProductoVariaciones(producto);
        setVariaciones([
            { talla: '', color: '', cantidad: 1, codigo_individual: '' }
        ]);
        setShowVariacionesModal(true);
    };

    const agregarFilaVariacion = () => {
        setVariaciones([...variaciones, { talla: '', color: '', cantidad: 1, codigo_individual: '' }]);
    };

    const eliminarFilaVariacion = (index) => {
        if (variaciones.length > 1) {
            const nuevasVariaciones = variaciones.filter((_, i) => i !== index);
            setVariaciones(nuevasVariaciones);
        }
    };

    const actualizarVariacion = (index, campo, valor) => {
        const nuevasVariaciones = [...variaciones];
        nuevasVariaciones[index][campo] = valor;
        setVariaciones(nuevasVariaciones);
    };

    const validarVariaciones = () => {
        for (let i = 0; i < variaciones.length; i++) {
            const variacion = variaciones[i];
            if (variacion.cantidad <= 0) {
                return `La cantidad en la fila ${i + 1} debe ser mayor a 0`;
            }
        }
        return null;
    };

    const guardarVariaciones = async () => {
        const error = validarVariaciones();
        if (error) {
            Swal.fire('Error', error, 'error');
            return;
        }

        try {
            const variacionesParaGuardar = [];

            variaciones.forEach(variacion => {
                for (let i = 0; i < variacion.cantidad; i++) {
                    // Generar código individual automáticamente incluyendo marca
                    let codigoIndividual = productoVariaciones.Codigo_Producto;

                    // Agregar marca si está disponible
                    if (productoVariaciones.Marca && productoVariaciones.Marca.trim() !== '') {
                        codigoIndividual += `-${productoVariaciones.Marca.trim()}`;
                    }

                    // Agregar talla si está especificada
                    if (variacion.talla && variacion.talla.trim() !== '') {
                        codigoIndividual += `-${variacion.talla.trim()}`;
                    }

                    // Agregar color si está especificado
                    if (variacion.color && variacion.color.trim() !== '') {
                        codigoIndividual += `-${variacion.color.trim()}`;
                    }

                    // Agregar número secuencial (siempre, para diferenciar unidades)
                    codigoIndividual += `-${String(i + 1).padStart(3, '0')}`;

                    // Si el usuario especificó un código personalizado, usarlo como base
                    if (variacion.codigo_individual && variacion.codigo_individual.trim() !== '') {
                        codigoIndividual = variacion.codigo_individual.trim();

                        // Agregar marca si está disponible
                        if (productoVariaciones.Marca && productoVariaciones.Marca.trim() !== '') {
                            codigoIndividual += `-${productoVariaciones.Marca.trim()}`;
                        }

                        // Agregar talla si está especificada
                        if (variacion.talla && variacion.talla.trim() !== '') {
                            codigoIndividual += `-${variacion.talla.trim()}`;
                        }

                        // Agregar color si está especificado
                        if (variacion.color && variacion.color.trim() !== '') {
                            codigoIndividual += `-${variacion.color.trim()}`;
                        }

                        // Agregar número secuencial
                        codigoIndividual += `-${String(i + 1).padStart(3, '0')}`;
                    }

                    variacionesParaGuardar.push({
                        ID_Producto: productoVariaciones.ID_Producto,
                        Talla: variacion.talla || null,
                        Color: variacion.color || null,
                        Codigo_Individual: codigoIndividual,
                        Estado_Unidad: 'Disponible',
                        Usuario_Registro: userName
                    });
                }
            });

            const response = await Axios.post(`${config.API_URL}/agregarVariacionesInventario`, {
                variaciones: variacionesParaGuardar
            }, {
                headers: { Authorization: `Bearer ${cookies.token}` }
            });

            if (response.data.success) {
                Swal.fire({
                    title: 'Éxito',
                    text: `Se agregaron ${variacionesParaGuardar.length} unidades al inventario`,
                    icon: 'success'
                });

                cargarDetalleInventario();
                setShowVariacionesModal(false);
            } else {
                Swal.fire('Error', response.data.message || 'Error al agregar variaciones', 'error');
            }

        } catch (error) {
            console.error('Error al guardar variaciones:', error);
            Swal.fire('Error', 'Error al guardar las variaciones', 'error');
        }
    };

    // ===============================
    // FUNCIONES PARA GENERAR REPORTES PDF
    // ===============================
    const generarReportePDF = async () => {
        try {
            const doc = new jsPDF();

            // Configuración del documento
            doc.setFontSize(16);
            doc.setFont(undefined, 'bold');
            doc.text(`Reporte de Inventario - ${NombreEmpresa}`, 20, 20);

            doc.setFontSize(10);
            doc.setFont(undefined, 'normal');

            const fechaActual = new Date().toLocaleDateString('es-CL');
            doc.text(`Fecha de generación: ${fechaActual}`, 20, 30);

            if (fechaDesde || fechaHasta) {
                const periodo = `Periodo: ${fechaDesde || 'Sin inicio'} - ${fechaHasta || 'Sin fin'}`;
                doc.text(periodo, 20, 35);
            }

            let yPosition = 50;

            switch (tipoReporte) {
                case 'tipos':
                    await generarReportePorTipos(doc, yPosition);
                    break;
                case 'catalogo':
                    await generarReporteCatalogo(doc, yPosition);
                    break;
                case 'detallado':
                    await generarReporteDetallado(doc, yPosition);
                    break;
            }

            const nombreArchivo = `reporte_inventario_${tipoReporte}_${new Date().getTime()}.pdf`;
            doc.save(nombreArchivo);

            Swal.fire({
                title: 'Reporte generado',
                text: 'El reporte PDF se ha descargado correctamente',
                icon: 'success'
            });

            setShowReporteModal(false);

        } catch (error) {
            console.error('Error al generar reporte:', error);
            Swal.fire({
                title: 'Error',
                text: 'No se pudo generar el reporte PDF',
                icon: 'error'
            });
        }
    };

    const generarReportePorTipos = async (doc, startY) => {
        const response = await Axios.get(`${config.API_URL}/getInventarioTipos`, {
            headers: { Authorization: `Bearer ${cookies.token}` },
            params: { idEmpresa: idEmpresa }
        });

        const datosReporte = response.data;

        doc.setFontSize(14);
        doc.setFont(undefined, 'bold');
        doc.text('Inventario por Tipos', 20, startY);

        const tableData = datosReporte.map(tipo => [
            tipo.Nombre_Tipo,
            tipo.Total_Productos || 0,
            tipo.Total_Stock || 0,
            tipo.Stock_Disponible || 0,
            tipo.Stock_Asignado || 0,
            tipo.Es_EPP
        ]);

        doc.autoTable({
            startY: startY + 10,
            head: [['Tipo', 'Productos', 'Stock Total', 'Disponible', 'Asignado', 'EPP']],
            body: tableData,
            theme: 'striped',
            headStyles: { fillColor: [52, 58, 64] },
            margin: { left: 20, right: 20 }
        });
    };

    const generarReporteCatalogo = async (doc, startY) => {
        const response = await Axios.get(`${config.API_URL}/getProductosInventario`, {
            headers: { Authorization: `Bearer ${cookies.token}` },
            params: { idEmpresa: idEmpresa }
        });

        const productos = response.data;

        doc.setFontSize(14);
        doc.setFont(undefined, 'bold');
        doc.text('Catálogo de Productos', 20, startY);

        const tableData = productos.map(producto => [
            producto.Codigo_Producto,
            producto.Nombre_Producto,
            producto.Nombre_Tipo,
            producto.Stock_Total || 0,
            producto.Stock_Disponible || 0,
            producto.Marca || 'Sin marca'
        ]);

        doc.autoTable({
            startY: startY + 10,
            head: [['Código', 'Producto', 'Tipo', 'Stock', 'Disponible', 'Marca']],
            body: tableData,
            theme: 'striped',
            headStyles: { fillColor: [52, 58, 64] },
            margin: { left: 20, right: 20 },
            columnStyles: {
                5: { cellWidth: 30 }
            }
        });
    };

    const generarReporteDetallado = async (doc, startY) => {
        const response = await Axios.get(`${config.API_URL}/getDetalleInventario`, {
            headers: { Authorization: `Bearer ${cookies.token}` },
            params: { idEmpresa: idEmpresa }
        });

        const detalle = response.data;

        doc.setFontSize(14);
        doc.setFont(undefined, 'bold');
        doc.text('Inventario Detallado', 20, startY);

        const tableData = detalle.map(item => {
            let trabajadorInfo = '';
            if (incluirAsignaciones && item.Estado_Unidad === 'Asignado' && item.Nombre_Trabajador) {
                trabajadorInfo = item.Nombre_Trabajador;
            }

            return [
                item.Codigo_Individual || `ID-${item.ID_Detalle}`,
                item.Codigo_Producto,
                item.Nombre_Producto,
                item.Talla || 'N/A',
                item.Estado_Unidad,
                item.Fecha_Ingreso ? new Date(item.Fecha_Ingreso).toLocaleDateString('es-CL') : 'N/A',
                trabajadorInfo
            ];
        });

        const headers = incluirAsignaciones
            ? [['Código Unidad', 'Código Producto', 'Producto', 'Talla', 'Estado', 'Fecha Ingreso', 'Asignado a']]
            : [['Código Unidad', 'Código Producto', 'Producto', 'Talla', 'Estado', 'Fecha Ingreso']];

        doc.autoTable({
            startY: startY + 10,
            head: headers,
            body: incluirAsignaciones ? tableData : tableData.map(row => row.slice(0, -1)),
            theme: 'striped',
            headStyles: { fillColor: [52, 58, 64] },
            margin: { left: 20, right: 20 },
            styles: { fontSize: 8 },
            columnStyles: {
                3: { cellWidth: 20 },
                6: { cellWidth: 35 }
            }
        });
    };

    return (
        <div id="wrapper">
            <Sidebar
                imageUrl={imageUrl}
                isComponentsCollapsed={isComponentsCollapsed}
                toggleCollapse={toggleCollapse}
                setIsComponentsCollapsed={setIsComponentsCollapsed}
                isUtilitiesCollapsed={isUtilitiesCollapsed}
                setIsUtilitiesCollapsed={setIsUtilitiesCollapsed}
                isContabilidadCollapsed={isContabilidadCollapsed}
                setIsContabilidadCollapsed={setIsContabilidadCollapsed}
                isPrevencion={isPrevencion}
                setisPrevencionCollapsed={setisPrevencionCollapsed}
                isLogistica={isLogistica}
                setisLogisticaCollapsed={setisLogisticaCollapsed}
                isInventario={isInventario}
                setisIventatioCollapsed={setisIventatioCollapsed}
                cookies={cookies}
            />

            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">

                    <div className="container-fluid">
                        {/* Header */}
                        <div className="d-sm-flex align-items-center justify-content-between mb-4">
                            <h1 className="h3 mb-0 text-gray-800">
                                <i className="fas fa-boxes"></i> Gestión de Inventario - {NombreEmpresa}
                            </h1>
                            <div>
                                <button
                                    className="btn btn-success mr-2"
                                    onClick={() => {
                                        const link = document.createElement('a');
                                        link.href = `${process.env.PUBLIC_URL}/Plantilla_EPP_Mensual.pdf`;
                                        link.download = 'Plantilla_EPP_Mensual.pdf';
                                        document.body.appendChild(link);
                                        link.click();
                                        document.body.removeChild(link);
                                    }}

                                >
                                    <i className="fas fa-tags"></i> Plantilla EPP Mensual
                                </button>
                                <button
                                    className="btn btn-secondary mr-2"
                                    onClick={() => {
                                        limpiarFormularioTipo();
                                        setShowTipoModal(true);
                                    }}
                                >
                                    <i className="fas fa-tags"></i> Gestionar Tipos
                                </button>
                                <button
                                    className="btn btn-info mr-2"
                                    onClick={() => setShowReporteModal(true)}
                                >
                                    <i className="fas fa-file-pdf"></i> Reporte PDF
                                </button>
                                <button
                                    className="btn btn-primary"
                                    onClick={() => {
                                        limpiarFormulario();
                                        setShowModal(true);
                                    }}
                                >
                                    <i className="fas fa-plus"></i> Nuevo Producto
                                </button>
                            </div>
                        </div>

                        {/* Pestañas */}
                        <ul className="nav nav-tabs" id="inventarioTabs" role="tablist">
                            <li className="nav-item" role="presentation">
                                <button
                                    className={`nav-link ${vistaActual === 'productos' ? 'active' : ''}`}
                                    onClick={() => setVistaActual('productos')}
                                >
                                    <i className="fas fa-list"></i> Catálogo de Productos
                                </button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button
                                    className={`nav-link ${vistaActual === 'detalle' ? 'active' : ''}`}
                                    onClick={() => setVistaActual('detalle')}
                                >
                                    <i className="fas fa-warehouse"></i> Inventario Detallado
                                </button>
                            </li>
                        </ul>

                        {/* Contenido de las pestañas */}
                        <div className="card shadow mb-4 mt-3">
                            <div className="card-body">
                                {vistaActual === 'productos' && (
                                    <div>
                                        <h5 className="card-title">
                                            <i className="fas fa-list"></i> Catálogo de Productos
                                        </h5>

                                        <div className="table-responsive">
                                            <table className="table table-bordered" id="productosTable" width="100%" cellSpacing="0">
                                                <thead>
                                                    <tr>
                                                        <th>Código</th>
                                                        <th>Nombre</th>
                                                        <th>Tipo</th>
                                                        <th>Marca</th>
                                                        <th>Estado</th>
                                                        <th>Stock Total</th>
                                                        <th>Disponible</th>
                                                        <th>Fecha Creación</th>
                                                        <th>Acciones</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {Array.isArray(productos) && productos.length > 0 ? (
                                                        productos.map((producto) => {
                                                            const stockTotal = detalleInventario.filter(d => d.ID_Producto === producto.ID_Producto).length;
                                                            const stockDisponible = detalleInventario.filter(d => d.ID_Producto === producto.ID_Producto && d.Estado_Unidad === 'Disponible').length;

                                                            return (
                                                                <tr key={producto.ID_Producto}>
                                                                    <td>{producto.Codigo_Producto}</td>
                                                                    <td>{producto.Nombre_Producto}</td>
                                                                    <td>{producto.Nombre_Tipo}</td>
                                                                    <td>{producto.Marca || '-'}</td>
                                                                    <td>
                                                                        <span className={`badge ${producto.Estado === 'Activo' ? 'badge-success' : 'badge-secondary'}`}>
                                                                            {producto.Estado}
                                                                        </span>
                                                                    </td>
                                                                    <td>
                                                                        <span className="badge badge-info">{stockTotal}</span>
                                                                    </td>
                                                                    <td>
                                                                        <span className="badge badge-success">{stockDisponible}</span>
                                                                    </td>
                                                                    <td>{new Date(producto.Fecha_Creacion).toLocaleDateString()}</td>
                                                                    <td>
                                                                        <button
                                                                            className="btn btn-info btn-sm mr-1"
                                                                            onClick={() => abrirModalVariaciones(producto)}
                                                                            title="Agregar Variaciones"
                                                                        >
                                                                            <i className="fas fa-plus-square"></i>
                                                                        </button>
                                                                        <button
                                                                            className="btn btn-warning btn-sm mr-1"
                                                                            onClick={() => editarProducto(producto)}
                                                                            title="Editar"
                                                                        >
                                                                            <i className="fas fa-edit"></i>
                                                                        </button>
                                                                        <button
                                                                            className="btn btn-danger btn-sm"
                                                                            onClick={() => eliminarProducto(producto)}
                                                                            title="Eliminar"
                                                                        >
                                                                            <i className="fas fa-trash"></i>
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="9" className="text-center text-muted">
                                                                <i className="fas fa-inbox fa-2x mb-2"></i>
                                                                <br />
                                                                No hay productos disponibles
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                )}

                                {vistaActual === 'detalle' && (
                                    <div>
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <h5 className="card-title mb-0">
                                                <i className="fas fa-warehouse"></i> Inventario Detallado
                                            </h5>

                                            {/* Breadcrumb de navegación */}
                                            {rutaNavegacion.length > 0 && (
                                                <nav aria-label="breadcrumb">
                                                    <ol className="breadcrumb mb-0">
                                                        <li className="breadcrumb-item">
                                                            <button
                                                                className="btn btn-link p-0 text-decoration-none"
                                                                onClick={() => navegarANivel("tipos")}
                                                            >
                                                                <i className="fas fa-home"></i> Inicio
                                                            </button>
                                                        </li>
                                                        {rutaNavegacion.map((ruta, index) => (
                                                            <li key={index} className="breadcrumb-item">
                                                                <button
                                                                    className="btn btn-link p-0 text-decoration-none"
                                                                    onClick={() => navegarANivel(ruta.nivel)}
                                                                >
                                                                    {ruta.texto}
                                                                </button>
                                                            </li>
                                                        ))}
                                                        {nivelActual === "unidades" && (
                                                            <li className="breadcrumb-item active" aria-current="page">
                                                                {productoSeleccionadoDetalle?.Nombre_Producto}
                                                            </li>
                                                        )}
                                                    </ol>
                                                </nav>
                                            )}
                                        </div>

                                        {/* Nivel 1: Tipos de Producto */}
                                        {nivelActual === "tipos" && (
                                            <div className="row">
                                                {tiposProducto.map((tipo) => {
                                                    const productosDelTipo = getProductosPorTipo(tipo.ID_Tipo);
                                                    const totalUnidades = productosDelTipo.reduce((total, producto) => {
                                                        return total + getUnidadesPorProducto(producto.ID_Producto).length;
                                                    }, 0);

                                                    return (
                                                        <div key={tipo.ID_Tipo} className="col-md-4 col-lg-3 mb-4">
                                                            <div
                                                                className="card h-100 shadow-sm hover-shadow"
                                                                style={{ cursor: 'pointer', transition: 'all 0.3s' }}
                                                                onClick={() => navegarATipo(tipo)}
                                                            >
                                                                <div className="card-body text-center">
                                                                    <div className="mb-3">
                                                                        <i
                                                                            className={`${getIconoTipo(tipo.Nombre_Tipo)} fa-3x text-primary`}
                                                                        ></i>
                                                                    </div>
                                                                    <h6 className="card-title">{tipo.Nombre_Tipo}</h6>
                                                                    <p className="card-text text-muted small">
                                                                        {tipo.Descripcion || 'Sin descripción'}
                                                                    </p>
                                                                    <div className="d-flex justify-content-between align-items-center">
                                                                        <small className="text-muted">
                                                                            {productosDelTipo.length} productos
                                                                        </small>
                                                                        <small className="text-muted">
                                                                            {totalUnidades} unidades
                                                                        </small>
                                                                    </div>
                                                                    {tipo.Es_EPP === 'Si' && (
                                                                        <span className="badge badge-warning mt-2">
                                                                            <i className="fas fa-shield-alt"></i> EPP
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        )}

                                        {/* Nivel 2: Productos del tipo seleccionado */}
                                        {nivelActual === "productos" && tipoSeleccionadoDetalle && (
                                            <div>
                                                {getProductosPorTipo(tipoSeleccionadoDetalle.ID_Tipo).length > 0 ? (
                                                    <div className="row">
                                                        {getProductosPorTipo(tipoSeleccionadoDetalle.ID_Tipo).map((producto) => {
                                                            const unidadesDelProducto = getUnidadesPorProducto(producto.ID_Producto);
                                                            const disponibles = unidadesDelProducto.filter(u => u.Estado_Unidad === 'Disponible').length;
                                                            const asignadas = unidadesDelProducto.filter(u => u.Estado_Unidad === 'Asignado').length;

                                                            return (
                                                                <div key={producto.ID_Producto} className="col-md-6 col-lg-4 mb-4">
                                                                    <div
                                                                        className="card h-100 shadow-sm hover-shadow"
                                                                        style={{ cursor: 'pointer', transition: 'all 0.3s' }}
                                                                        onClick={() => navegarAProducto(producto)}
                                                                    >
                                                                        <div className="card-body">
                                                                            <div className="d-flex justify-content-between align-items-start mb-2">
                                                                                <h6 className="card-title mb-0">{producto.Nombre_Producto}</h6>
                                                                                <span className={`badge ${producto.Estado === 'Activo' ? 'badge-success' : 'badge-secondary'}`}>
                                                                                    {producto.Estado}
                                                                                </span>
                                                                            </div>
                                                                            <p className="text-muted small mb-2">
                                                                                <strong>Código:</strong> {producto.Codigo_Producto}
                                                                            </p>
                                                                            <p className="text-muted small mb-3">
                                                                                <strong>Marca:</strong> {producto.Marca || 'Sin marca'}
                                                                            </p>

                                                                            <div className="row text-center">
                                                                                <div className="col-4">
                                                                                    <div className="text-success">
                                                                                        <i className="fas fa-check-circle"></i>
                                                                                        <div className="font-weight-bold">{disponibles}</div>
                                                                                        <small>Disponibles</small>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-4">
                                                                                    <div className="text-primary">
                                                                                        <i className="fas fa-user"></i>
                                                                                        <div className="font-weight-bold">{asignadas}</div>
                                                                                        <small>Asignadas</small>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-4">
                                                                                    <div className="text-info">
                                                                                        <i className="fas fa-boxes"></i>
                                                                                        <div className="font-weight-bold">{unidadesDelProducto.length}</div>
                                                                                        <small>Total</small>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                ) : (
                                                    <div className="text-center py-5">
                                                        <div className="mb-4">
                                                            <i className="fas fa-folder-open fa-5x text-muted"></i>
                                                        </div>
                                                        <h5 className="text-muted mb-3">¡Esta categoría está vacía!</h5>
                                                        <p className="text-muted mb-4">No hay productos registrados en "{tipoSeleccionadoDetalle.Nombre_Tipo}"</p>
                                                        <button
                                                            className="btn btn-primary"
                                                            onClick={() => {
                                                                setVistaActual("productos");
                                                                setIdTipo(tipoSeleccionadoDetalle.ID_Tipo);
                                                                setShowModal(true);
                                                            }}
                                                        >
                                                            <i className="fas fa-plus"></i> Agregar productos nuevos
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        )}

                                        {/* Nivel 3: Lista detallada de unidades */}
                                        {nivelActual === "unidades" && productoSeleccionadoDetalle && (
                                            <div>
                                                <div className="mb-3">
                                                    <h6 className="text-primary">
                                                        <i className="fas fa-list"></i> Unidades de: {productoSeleccionadoDetalle.Nombre_Producto}
                                                    </h6>
                                                    <p className="text-muted">Código del producto: {productoSeleccionadoDetalle.Codigo_Producto}</p>
                                                </div>

                                                <div className="table-responsive">
                                                    <table className="table table-bordered table-hover" width="100%" cellSpacing="0">
                                                        <thead className="thead-light">
                                                            <tr>
                                                                <th>Código Individual</th>
                                                                <th>Talla</th>
                                                                <th>Color</th>
                                                                <th>Estado</th>
                                                                <th>Trabajador Asignado</th>
                                                                <th>Fecha Ingreso</th>
                                                                <th>Observaciones</th>
                                                                <th>Acciones</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {getUnidadesPorProducto(productoSeleccionadoDetalle.ID_Producto).map((detalle) => (
                                                                <tr key={detalle.ID_Detalle}>
                                                                    <td>
                                                                        <code>{detalle.Codigo_Individual || '-'}</code>
                                                                    </td>
                                                                    <td>{detalle.Talla || '-'}</td>
                                                                    <td>{detalle.Color || '-'}</td>
                                                                    <td>
                                                                        <span className={`badge ${detalle.Estado_Unidad === 'Disponible' ? 'badge-success' :
                                                                            detalle.Estado_Unidad === 'Asignado' ? 'badge-primary' :
                                                                                detalle.Estado_Unidad === 'En_Reparacion' ? 'badge-warning' :
                                                                                    'badge-danger'
                                                                            }`}>
                                                                            {detalle.Estado_Unidad.replace('_', ' ')}
                                                                        </span>
                                                                    </td>
                                                                    <td>{detalle.Nombre_Trabajador || '-'}</td>
                                                                    <td>{new Date(detalle.Fecha_Ingreso).toLocaleDateString()}</td>
                                                                    <td>{detalle.Observaciones || '-'}</td>
                                                                    <td>
                                                                        <div className="btn-group" role="group">
                                                                            <button
                                                                                className="btn btn-sm btn-outline-primary"
                                                                                onClick={() => cambiarEstadoUnidad(detalle)}
                                                                                title="Cambiar estado"
                                                                            >
                                                                                <i className="fas fa-exchange-alt"></i>
                                                                            </button>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>

                                                {getUnidadesPorProducto(productoSeleccionadoDetalle.ID_Producto).length === 0 && (
                                                    <div className="text-center text-muted py-4">
                                                        <i className="fas fa-inbox fa-3x mb-3"></i>
                                                        <p>No hay unidades registradas para este producto</p>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal para crear/editar producto */}
            {showModal && (
                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header" style={{ position: 'relative' }}>
                                <h5 className="modal-title">
                                    <i className="fas fa-boxes"></i> {editar ? 'Editar Producto' : 'Nuevo Producto'}
                                </h5>
                                <button
                                    type="button"
                                    style={{
                                        position: 'absolute',
                                        top: '12px',
                                        right: '16px',
                                        background: 'none',
                                        border: 'none',
                                        fontSize: '24px',
                                        color: '#666',
                                        cursor: 'pointer',
                                        padding: '0',
                                        lineHeight: '1'
                                    }}
                                    onClick={() => {
                                        setShowModal(false);
                                        limpiarFormulario();
                                    }}
                                >
                                    ×
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    {/* Información del Producto */}
                                    <div className="col-md-6">
                                        <h6 className="text-primary">Información del Producto</h6>

                                        <div className="form-group">
                                            <label>Código del Producto {!editar && <small className="text-muted">(se genera automáticamente)</small>}</label>
                                            {editar ? (
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={codigoProducto}
                                                    readOnly
                                                    style={{ backgroundColor: '#f8f9fa' }}
                                                />
                                            ) : (
                                                <div className="form-control bg-light text-muted d-flex align-items-center codigo-preview-producto" style={{ minHeight: '38px' }}>
                                                    <i className="fas fa-eye mr-2 text-success"></i>
                                                    <span>{codigoPreview || "Vista previa del código..."}</span>
                                                </div>
                                            )}
                                        </div>

                                        <div className="form-group">
                                            <label>Nombre del Producto *</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={nombreProducto}
                                                onChange={(e) => setNombreProducto(e.target.value)}
                                                placeholder="Ej: Casco de Seguridad"
                                            />
                                        </div>

                                        <div className="form-group">
                                            <label>Tipo de Producto *</label>
                                            <select
                                                className="form-control"
                                                value={idTipo}
                                                onChange={(e) => setIdTipo(e.target.value)}
                                            >
                                                <option value="">Seleccione un tipo</option>
                                                {tiposProducto.map((tipo) => (
                                                    <option key={tipo.ID_Tipo} value={tipo.ID_Tipo}>
                                                        {tipo.Nombre_Tipo} {tipo.Es_EPP === 'Si' && '(EPP)'}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="form-group">
                                            <label>Marca</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={marca}
                                                onChange={(e) => setMarca(e.target.value)}
                                                placeholder="Ej: 3M, MSA, Stanley"
                                            />
                                        </div>

                                        <div className="form-group">
                                            <label>Estado</label>
                                            <select
                                                className="form-control"
                                                value={estado}
                                                onChange={(e) => setEstado(e.target.value)}
                                            >
                                                <option value="Activo">Activo</option>
                                                <option value="Inactivo">Inactivo</option>
                                            </select>
                                        </div>
                                    </div>

                                    {/* Detalles del Inventario (solo para productos nuevos) */}
                                    {!editar && (
                                        <div className="col-md-6">
                                            <h6 className="text-primary">Detalles del Inventario</h6>

                                            <div className="form-group">
                                                <label>Cantidad a Agregar</label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    value={cantidadAgregar}
                                                    onChange={(e) => setCantidadAgregar(parseInt(e.target.value) || 1)}
                                                    min="1"
                                                />
                                            </div>

                                            <div className="form-group">
                                                <label>Vista Previa Código Individual <small className="text-muted">(se genera automáticamente)</small></label>
                                                <div className="form-control bg-light text-muted d-flex align-items-center codigo-preview-individual" style={{ minHeight: '38px' }}>
                                                    <i className="fas fa-barcode mr-2 text-primary"></i>
                                                    <span>{codigoIndividualPreview || "Configure nombre del producto y marca primero..."}</span>
                                                </div>
                                                <small className="form-text text-muted">
                                                    {cantidadAgregar > 1 && `Se generarán ${cantidadAgregar} códigos con numeración secuencial`}
                                                </small>
                                            </div>

                                            <div className="form-group">
                                                <label>Talla</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={talla}
                                                    onChange={(e) => setTalla(e.target.value)}
                                                    placeholder="Ej: S, M, L, 38, 40, etc."
                                                />
                                            </div>

                                            <div className="form-group">
                                                <label>Color</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={color}
                                                    onChange={(e) => setColor(e.target.value)}
                                                    placeholder="Ej: Blanco, Negro, Azul"
                                                />
                                            </div>

                                            <div className="form-group">
                                                <label>Estado de las Unidades</label>
                                                <select
                                                    className="form-control"
                                                    value={estadoUnidad}
                                                    onChange={(e) => setEstadoUnidad(e.target.value)}
                                                >
                                                    <option value="Disponible">Disponible</option>
                                                    <option value="En_Reparacion">En Reparación</option>
                                                    <option value="Dado_De_Baja">Dado de Baja</option>
                                                </select>
                                            </div>

                                            <div className="form-group">
                                                <label>Observaciones</label>
                                                <textarea
                                                    className="form-control"
                                                    rows="3"
                                                    value={observaciones}
                                                    onChange={(e) => setObservaciones(e.target.value)}
                                                    placeholder="Observaciones adicionales..."
                                                ></textarea>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => {
                                        setShowModal(false);
                                        limpiarFormulario();
                                    }}
                                >
                                    <i className="fas fa-times"></i> Cancelar
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={confirmarRegistro}
                                >
                                    <i className="fas fa-save"></i> {editar ? 'Actualizar' : 'Registrar'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal para gestionar tipos de producto */}
            {showTipoModal && (
                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header" style={{ position: 'relative' }}>
                                <h4 className="modal-title">
                                    <i className="fas fa-tags"></i> {editarTipo ? 'Editar' : 'Nuevo'} Tipo de Producto
                                </h4>
                                <button
                                    type="button"
                                    style={{
                                        position: 'absolute',
                                        top: '12px',
                                        right: '16px',
                                        background: 'none',
                                        border: 'none',
                                        fontSize: '24px',
                                        color: '#666',
                                        cursor: 'pointer',
                                        padding: '0',
                                        lineHeight: '1'
                                    }}
                                    onClick={() => {
                                        setShowTipoModal(false);
                                        limpiarFormularioTipo();
                                    }}
                                >
                                    ×
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="form-group">
                                    <label htmlFor="nombreTipo">Nombre del Tipo *</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="nombreTipo"
                                        value={nombreTipo}
                                        onChange={(e) => setNombreTipo(e.target.value)}
                                        placeholder="Ej: Cascos, Guantes, Uniformes..."
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="descripcionTipo">Descripción</label>
                                    <textarea
                                        className="form-control"
                                        id="descripcionTipo"
                                        rows="3"
                                        value={descripcionTipo}
                                        onChange={(e) => setDescripcionTipo(e.target.value)}
                                        placeholder="Descripción del tipo de producto (opcional)"
                                    ></textarea>
                                </div>

                                <div className="form-group">
                                    <label htmlFor="esEPP">¿Es Equipo de Protección Personal (EPP)?</label>
                                    <select
                                        className="form-control"
                                        id="esEPP"
                                        value={esEPP}
                                        onChange={(e) => setEsEPP(e.target.value)}
                                    >
                                        <option value="No">No</option>
                                        <option value="Si">Sí</option>
                                    </select>
                                </div>

                                {/* Tabla de tipos existentes */}
                                <div className="mt-4">
                                    <h6><i className="fas fa-list"></i> Tipos Existentes</h6>
                                    <div className="table-responsive" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                        <table className="table table-sm table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Nombre</th>
                                                    <th>EPP</th>
                                                    <th>Acciones</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {tiposProducto.map((tipo) => (
                                                    <tr key={tipo.ID_Tipo}>
                                                        <td>{tipo.Nombre_Tipo}</td>
                                                        <td>
                                                            <span className={`badge ${tipo.Es_EPP === 'Si' ? 'badge-success' : 'badge-secondary'}`}>
                                                                {tipo.Es_EPP === 'Si' ? 'Sí' : 'No'}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <button
                                                                className="btn btn-sm btn-warning mr-1"
                                                                onClick={() => editarTipoProducto(tipo)}
                                                                title="Editar"
                                                            >
                                                                <i className="fas fa-edit"></i>
                                                            </button>
                                                            <button
                                                                className="btn btn-sm btn-danger"
                                                                onClick={() => eliminarTipoProducto(tipo)}
                                                                title="Eliminar"
                                                            >
                                                                <i className="fas fa-trash"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => {
                                        setShowTipoModal(false);
                                        limpiarFormularioTipo();
                                    }}
                                >
                                    <i className="fas fa-times"></i> Cerrar
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={confirmarRegistroTipo}
                                >
                                    <i className="fas fa-save"></i> {editarTipo ? 'Actualizar' : 'Registrar'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal para reporte PDF */}
            {showReporteModal && (
                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1" role="dialog">
                    <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header" style={{ position: 'relative' }}>
                                <h5 className="modal-title">
                                    <i className="fas fa-file-pdf"></i> Generar Reporte PDF
                                </h5>
                                <button
                                    type="button"
                                    style={{
                                        position: 'absolute',
                                        top: '12px',
                                        right: '16px',
                                        background: 'none',
                                        border: 'none',
                                        fontSize: '24px',
                                        color: '#666',
                                        cursor: 'pointer',
                                        padding: '0',
                                        lineHeight: '1'
                                    }}
                                    onClick={() => setShowReporteModal(false)}
                                >
                                    ×
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="form-group">
                                    <label>Tipo de Reporte:</label>
                                    <select
                                        className="form-control"
                                        value={tipoReporte}
                                        onChange={(e) => setTipoReporte(e.target.value)}
                                    >
                                        <option value="tipos">Por Tipos de Producto</option>
                                        <option value="catalogo">Catálogo de Productos</option>
                                        <option value="detallado">Inventario Detallado</option>
                                    </select>
                                </div>

                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Fecha Desde (opcional):</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={fechaDesde}
                                                onChange={(e) => setFechaDesde(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Fecha Hasta (opcional):</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={fechaHasta}
                                                onChange={(e) => setFechaHasta(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                </div>

                                {tipoReporte === 'detallado' && (
                                    <div className="form-group">
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="incluirAsignaciones"
                                                checked={incluirAsignaciones}
                                                onChange={(e) => setIncluirAsignaciones(e.target.checked)}
                                            />
                                            <label className="form-check-label" htmlFor="incluirAsignaciones">
                                                Incluir información de trabajadores asignados
                                            </label>
                                        </div>
                                    </div>
                                )}

                                <div className="alert alert-info">
                                    <strong>Información del reporte:</strong>
                                    <ul className="mb-0 mt-2">
                                        {tipoReporte === 'tipos' && (
                                            <>
                                                <li>Resumen por tipos de producto</li>
                                                <li>Totales de stock por categoría</li>
                                                <li>Cantidad de productos disponibles y asignados</li>
                                            </>
                                        )}
                                        {tipoReporte === 'catalogo' && (
                                            <>
                                                <li>Lista completa de productos</li>
                                                <li>Códigos, nombres y tipos</li>
                                                <li>Stock disponible por producto</li>
                                            </>
                                        )}
                                        {tipoReporte === 'detallado' && (
                                            <>
                                                <li>Detalle unidad por unidad</li>
                                                <li>Números de serie y estados</li>
                                                <li>Información de asignaciones (opcional)</li>
                                            </>
                                        )}
                                    </ul>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => setShowReporteModal(false)}
                                >
                                    <i className="fas fa-times"></i> Cancelar
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-success"
                                    onClick={generarReportePDF}
                                >
                                    <i className="fas fa-download"></i> Generar PDF
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal para agregar variaciones */}
            {showVariacionesModal && (
                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1" role="dialog">
                    <div className="modal-dialog modal-xl modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header" style={{ position: 'relative' }}>
                                <h5 className="modal-title">
                                    <i className="fas fa-plus-square"></i> Agregar Variaciones - {productoVariaciones?.Nombre_Producto}
                                </h5>
                                <button
                                    type="button"
                                    style={{
                                        position: 'absolute',
                                        top: '12px',
                                        right: '16px',
                                        background: 'none',
                                        border: 'none',
                                        fontSize: '24px',
                                        color: '#666',
                                        cursor: 'pointer',
                                        padding: '0',
                                        lineHeight: '1'
                                    }}
                                    onClick={() => setShowVariacionesModal(false)}
                                >
                                    ×
                                </button>
                            </div>
                            <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                                <div className="alert alert-info">
                                    <strong>Información:</strong> Agregue las diferentes variaciones (tallas, colores) del producto <strong>{productoVariaciones?.Nombre_Producto}</strong>.
                                    Los códigos individuales se generan automáticamente basándose en: <code>{productoVariaciones?.Codigo_Producto}-{productoVariaciones?.Marca}-Talla-Color-Número</code>
                                </div>

                                <div className="alert alert-success">
                                    <strong>Ejemplo de generación automática:</strong><br />
                                    • Talla: <code>L</code>, Color: <code>Negro</code> → Código: <code>{productoVariaciones?.Codigo_Producto}-{productoVariaciones?.Marca}-L-Negro-001</code><br />
                                    • Solo Talla: <code>42</code> → Código: <code>{productoVariaciones?.Codigo_Producto}-{productoVariaciones?.Marca}-42-001</code><br />
                                    • Sin talla/color → Código: <code>{productoVariaciones?.Codigo_Producto}-{productoVariaciones?.Marca}-001</code>
                                </div>

                                <div className="table-responsive">
                                    <table className="table table-bordered">
                                        <thead className="thead-dark">
                                            <tr>
                                                <th width="20%">Talla</th>
                                                <th width="20%">Color</th>
                                                <th width="15%">Cantidad</th>
                                                <th width="30%">Código Individual (opcional)</th>
                                                <th width="15%">Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {variaciones.map((variacion, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Ej: M, L, 42, etc."
                                                            value={variacion.talla}
                                                            onChange={(e) => actualizarVariacion(index, 'talla', e.target.value)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Ej: Negro, Blanco, etc."
                                                            value={variacion.color}
                                                            onChange={(e) => actualizarVariacion(index, 'color', e.target.value)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            min="1"
                                                            value={variacion.cantidad}
                                                            onChange={(e) => actualizarVariacion(index, 'cantidad', parseInt(e.target.value) || 1)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Código personalizado (opcional)"
                                                            value={variacion.codigo_individual}
                                                            onChange={(e) => actualizarVariacion(index, 'codigo_individual', e.target.value)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <button
                                                            type="button"
                                                            className="btn btn-success btn-sm mr-1"
                                                            onClick={agregarFilaVariacion}
                                                            title="Agregar fila"
                                                        >
                                                            <i className="fas fa-plus"></i>
                                                        </button>
                                                        {variaciones.length > 1 && (
                                                            <button
                                                                type="button"
                                                                className="btn btn-danger btn-sm"
                                                                onClick={() => eliminarFilaVariacion(index)}
                                                                title="Eliminar fila"
                                                            >
                                                                <i className="fas fa-trash"></i>
                                                            </button>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                <div className="alert alert-warning">
                                    <strong>Funcionamiento:</strong>
                                    <ul className="mb-0 mt-2">
                                        <li><strong>Códigos automáticos:</strong> Se generan como <code>{productoVariaciones?.Codigo_Producto}-Talla-Color-001</code></li>
                                        <li><strong>Talla y Color:</strong> Opcionales, pero se agregan al código si están especificados</li>
                                        <li><strong>Numeración:</strong> Cada unidad recibe un número secuencial (001, 002, 003...)</li>
                                        <li><strong>Código personalizado:</strong> Si especifica uno, reemplaza el código del producto base</li>
                                        <li><strong>Estado inicial:</strong> Todas las unidades se crean como "Disponible"</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => setShowVariacionesModal(false)}
                                >
                                    <i className="fas fa-times"></i> Cancelar
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-success"
                                    onClick={guardarVariaciones}
                                >
                                    <i className="fas fa-save"></i> Guardar Variaciones
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Inventario;
